export default __webpack_public_path__ + "static/media/Silk-Serif-Medium-Italic.0b6065d7.otf";